// extracted by mini-css-extract-plugin
module.exports = {"InputIcon":"ToggleButton__InputIcon___3oNVK","InputIconActive":"ToggleButton__InputIconActive___23Wy0"};